import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "app-update-card card shadow-lg" };
const _hoisted_2 = { class: "card-body p-4" };
const _hoisted_3 = { class: "h5 fw-bold mb-2" };
const _hoisted_4 = { class: "text-muted small mb-4" };
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppAndroidUpdateModal',
    props: {
        show: { type: Boolean },
        mandatory: { type: Boolean },
        message: {},
        storeLabel: {},
        storeChannel: {},
        useAppGallery: { type: Boolean }
    },
    emits: ["update", "dismiss"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const storeButtonLabel = computed(() => {
            if (props.storeLabel?.trim())
                return props.storeLabel.trim();
            if (props.storeChannel === "appstore")
                return "Actualizar en App Store";
            if (props.storeChannel === "appgallery" || props.useAppGallery) {
                return "Actualizar en AppGallery";
            }
            return "Actualizar en Google Play";
        });
        const emitUpdate = () => {
            emit("update");
        };
        const emitDismiss = () => {
            emit("dismiss");
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                (_ctx.show)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["app-update-backdrop", { 'app-update-backdrop--mandatory': _ctx.mandatory }])
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "app-update-icon-wrap mb-3" }, [
                                    _createElementVNode("i", {
                                        class: "bi bi-phone-fill",
                                        "aria-hidden": "true"
                                    })
                                ], -1)),
                                _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.mandatory ? "Actualización requerida" : "Nueva versión disponible"), 1),
                                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.message), 1),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-primary w-100 py-2 mb-2",
                                    onClick: emitUpdate
                                }, _toDisplayString(storeButtonLabel.value), 1),
                                (!_ctx.mandatory)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "btn btn-outline-secondary w-100 py-2",
                                        onClick: emitDismiss
                                    }, " Ahora no "))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ], 2))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
